import React, { useEffect, useState } from 'react';
import { IEmpresas } from "../../interfaces/IEmpresas";
import { Modal } from 'react-bootstrap-v5';
import EmpresasNovoModal from './EmpresasNovoModal';
import RegimeNovoModal from './RegimeNovoModal';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import EmpresasService from '../../services/EmpresasService';
import Swal from 'sweetalert2';
import { IEmpresaRegimeTributario } from '../../interfaces/IEmpresaRegimeTributario';
import EmpresaRegimeTributarioService from '../../services/EmpresaRegimeTributarioService';

export default function EmpresasModal({ toggleModal, show, empresa, title }: { toggleModal: (carregarEmpresas?: boolean) => void, show: boolean, empresa: IEmpresas | null, title: string }) {

    const [abaSelecionada, setAbaSelecionada] = useState<string>('1');
    const [atualizarLista, setAtualizarLista] = useState<boolean>(false);
    const [empresaVM, setEmpresaVM] = useState<IEmpresas | null>(null);

    useEffect(() => {
        setEmpresaVM(empresa);
        formikRegimeTributario.setFieldValue('empresaID', empresa ? empresa.id : 0);
        
        // eslint-disable-next-line
    }, [empresa]);

    const empresasSchema = Yup.object().shape({
        cnpj: Yup.string().min(18, 'Mínimo 18 caracteres').max(18, 'Maximo 18 caracteres').required('CNPJ é obrigatório'),
        dataAberturaString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Maximo 10 caracteres').required('Data Abertura é obrigatório'),
        bairro: Yup.string().max(50, 'Maximo 50 caracteres').required('Bairro é obrigatório'),
        municipio: Yup.string().max(50, 'Maximo 50 caracteres').required('Municipio é obrigatório'),
        estado: Yup.string().min(2, 'Mínimo 2 caracteres').max(2, 'Maximo 2 caracteres').required('Estado é obrigatório'),
        razaoSocial: Yup.string().max(50, 'Maximo 50 caracteres').required('Razão Social é obrigatório'),
        email: Yup.string().max(50, 'Maximo 50 caracteres').required('Email é obrigatório').email('E-mail inválido'),
        nomeFantasia: Yup.string().max(50, 'Maximo 50 caracteres').required('Nome Fantasia é obrigatório'),
        porte: Yup.string().max(50, 'Maximo 50 caracteres').required('Porte é obrigatório'),
        telefone: Yup.string().min(13, 'Mínimo 13 caracteres').max(19, 'Maximo 19 caracteres').required('Telefone é obrigatório'),
        telefoneAdicional: Yup.string().min(13, 'Mínimo 13 caracteres').max(19, 'Maximo 19 caracteres').required('Telefone Adicional é obrigatório'),
        situacaoCadastral: Yup.string().max(50, 'Maximo 50 caracteres').required('Situação Cadastral é obrigatório'),
        dataSituacaoCadastralString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Maximo 10 caracteres').required('Data Situação Cadastral é obrigatório'),
        motivoSituacaoCadastral: Yup.string().max(50, 'Maximo 50 caracteres').required('Motivo Situação Cadastral é obrigatório'),
        situacaoEspecial: Yup.string().max(50, 'Maximo 50 caracteres').required('Situação Especial é obrigatório'),
        dataSituacaoEspecialString: Yup.string().min(10, 'Mínimo 10 caracteres').max(10, 'Maximo 10 caracteres').required('Data Situação Especial é obrigatório'),
        atividadePrincipal: Yup.string().max(50, 'Maximo 50 caracteres').required('Atividade Principal é obrigatório'),
        atividadeSecundaria: Yup.string().max(50, 'Maximo 50 caracteres').required('Atividade Segundaria é obrigatório'),
        endereco: Yup.string().max(50, 'Maximo 50 caracteres').required('Endereço é obrigatório'),
        numero: Yup.string().max(50, 'Maximo 50 caracteres').required('Numero é obrigatório'),
        complemento: Yup.string().max(50, 'Maximo 50 caracteres').required('Complemento é obrigatório'),
        cep: Yup.string().min(9, 'Mínimo 9 caracteres').max(9, 'Maximo 9 caracteres').required('CEP é obrigatório'),
        clienteID: Yup.string(),
    });

    const formInitialValues: IEmpresas = {
        id: 0,
        atividadePrincipal: "",
        atividadeSecundaria: "",
        bairro: "",
        cep: "",
        cnpj: "",
        complemento: "",
        dataAberturaString: '',
        dataSituacaoCadastralString: '',
        dataSituacaoEspecialString: '',
        email: "",
        endereco: "",
        estado: "",
        motivoSituacaoCadastral: "",
        municipio: "",
        nomeFantasia: "",
        numero: "",
        porte: "",
        razaoSocial: "",
        empresaRegimesTributarios: [],
        situacaoCadastral: "",
        situacaoEspecial: "",
        telefone: "",
        telefoneAdicional: "",
        clienteID: 0
    }

    const formikEmpresa = useFormik({
        initialValues: formInitialValues,
        validationSchema: empresasSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                let dataAberturaSplit = values.dataAberturaString?.split('/');
                let dataSituacaoCadastralSplit = values.dataSituacaoCadastralString?.split('/');
                let dataSituacaoEspecialSplit = values.dataSituacaoEspecialString?.split('/');


                if (dataAberturaSplit)
                    values.dataAbertura = new Date(`${dataAberturaSplit[2]}-${dataAberturaSplit[1]}-${dataAberturaSplit[0]}`);

                if (dataSituacaoCadastralSplit)
                    values.dataSituacaoCadastral = new Date(`${dataSituacaoCadastralSplit[2]}-${dataSituacaoCadastralSplit[1]}-${dataSituacaoCadastralSplit[0]}`);

                if (dataSituacaoEspecialSplit)
                    values.dataSituacaoEspecial = new Date(`${dataSituacaoEspecialSplit[2]}-${dataSituacaoEspecialSplit[1]}-${dataSituacaoEspecialSplit[0]}`);

                if (values.id === 0) {
                    await EmpresasService.criar(values)
                } else {
                    await EmpresasService.atualizar(values)
                }

                setSubmitting(false);

                await Swal.fire({
                    text: !values.id ? 'Empresa foi adicionada com sucesso' : 'Empresa foi editada com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });

                toggleModal(true);
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: 'Não foi possivel salvar a Empresa',
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }
        },
    });

    const regimeTributarioSchema = Yup.object().shape({
        anoOpcao: Yup.string().min(4, 'Mínimo 4 caracteres').max(4, 'Maximo 4 caracteres').required('Descrição é obrigatório'),
        regimeTributarioID: Yup.string().required('Descrição é obrigatório'),
    })

    const formikRegimeTributario = useFormik({
        initialValues: { anoOpcao: new Date().getFullYear(), regimeTributarioID: '', empresaID: empresa ? empresa.id : 0, id: 0 } as IEmpresaRegimeTributario,
        validationSchema: regimeTributarioSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                values.data = new Date();

                if(values.id === 0){
                    var result = await EmpresaRegimeTributarioService.criar(values);
                    if(empresaVM !== null){
                        var regimes = empresaVM.empresaRegimesTributarios;
                        regimes.push(result);
                        setEmpresaVM({...empresaVM, empresaRegimesTributarios: regimes});
                    }
                }
                
                setAtualizarLista(true);
                formikRegimeTributario.resetForm();

                await Swal.fire({
                    text: values.id === 0 ? 'Regime foi adicionada com sucesso' : 'Regime foi editado com sucesso',
                    timer: 4000,
                    icon: 'success',
                    showConfirmButton: false
                });
            } catch (error) {
                setSubmitting(false)
                Swal.fire({
                    text: 'Não foi possivel salvar a Regime',
                    timer: 4000,
                    icon: 'error',
                    showConfirmButton: false
                });
            }

            setSubmitting(false);
        },
    });

    const BotoesHeaderTabela = () => {
        const opcoesFiltros = [
            { id: '1', descricao: 'Cadastro Empresa' },
            { id: '2', descricao: 'Regime tributário' }
        ];

        return <>
            {
                opcoesFiltros.map((x, index) => <button key={index} disabled={x.id === '2' && empresa === null} type="submit" id={x.id} className={`btn btn-filtro ${x.id === abaSelecionada && 'ativo'}`} onClick={() => setAbaSelecionada(x.id)}>{x.descricao}</button>)
            }
        </>
    };

    return <Modal size='xl' centered={true} show={show} onHide={() => {
        setAbaSelecionada('1');
        toggleModal(atualizarLista);
    }
    }>
        <div className="modal-content">
            <div className="modal-header" style={{ padding: '10px 15px 5px 35px' }}>
                <h5 className="modal-title titulo-modal">{title}</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={() => {
                        setAbaSelecionada('1')
                        toggleModal(atualizarLista);
                    }} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body" style={{ padding: '10px' }}>
                <BotoesHeaderTabela />
                <EmpresasNovoModal formikEmpresa={formikEmpresa}  empresa={empresa} abaSelecionada={abaSelecionada} />

                {
                    empresaVM !== null && <RegimeNovoModal setEmpresa={setEmpresaVM} empresa={empresaVM} formikRegimeTributario={formikRegimeTributario} abaSelecionada={abaSelecionada} />
                }
            </div>
        </div>
        <div className="modal-footer" style={{ paddingTop: '10px', justifyContent: 'center' }}>
            <button disabled={formikEmpresa.isSubmitting} onClick={() => {
                setAbaSelecionada('1')
                toggleModal(atualizarLista);
            }} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
            <button disabled={formikEmpresa.isSubmitting || !formikEmpresa.isValid} onClick={() => formikEmpresa.submitForm()} type="button" className="btn btn-primario ms-5">
                {!formikEmpresa.isSubmitting && 'SALVAR'}
                {formikEmpresa.isSubmitting && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                        Salvando...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                )}
            </button>
        </div>
    </Modal>
}
